export const LOAD_ORDERS = "LOAD_ORDERS";
export const SET_RESULT = "SET_RESULT";